var React = require('react');

function BarsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z","fill":"white"}));
}

BarsIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BarsIcon;

BarsIcon.default = BarsIcon;
